import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import qs from "query-string";
import AppealOfficial from "./AppealOfficial";

export default function AppealForm() {
  const { search } = useLocation();

  const query = useMemo(() => {
    return qs.parse(search);
  }, [search]);

  if (query.type === "unofficial") return null;

  return <AppealOfficial />;
}
